import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['floatingSubmit', 'fallbackSubmit'];

  connect() {
    if (this.hasFallbackSubmitTarget) {
      this.fallbackSubmitTarget.hidden = true;
    }
  }

  displaySubmitBanner() {
    this.floatingSubmitTarget.hidden = false;
  }
}
